module.exports = __webpack_public_path__ + "static/media/How to manage Job check case and link it with Job information.17975a8b.png";